export const getDisplayValue = (loanTableData, key) => loanTableData?.[key] ?? '';
